import { System } from '@ecs/System';
import { Position } from '@components/Position';
import { Shield } from '@components/Shield';
import { ShieldProjector } from '@components/ShieldProjector';
import { Tag } from '@components/Tag';

/** Wardens recharge the shields of nearby allies, ignoring the normal regen delay. */
export class ShieldProjectorSystem extends System {
  update(deltaTime: number): void {
    const projectors = this.getEntitiesWithComponents(Position, ShieldProjector, Tag)
      .filter(e => e.getComponent(Tag)!.value === 'player');
    if (projectors.length === 0) return;

    const allies = this.getEntitiesWithComponents(Position, Shield, Tag)
      .filter(e => e.getComponent(Tag)!.value === 'player');

    for (const projectorEntity of projectors) {
      const origin = projectorEntity.getComponent(Position)!;
      const projector = projectorEntity.getComponent(ShieldProjector)!;

      for (const ally of allies) {
        const shield = ally.getComponent(Shield)!;
        if (shield.current >= shield.max) continue;

        const pos = ally.getComponent(Position)!;
        if (Math.hypot(pos.x - origin.x, pos.y - origin.y) > projector.range) continue;

        shield.current = Math.min(shield.max, shield.current + projector.rechargePerSecond * (deltaTime / 1000));
        if (shield.current > 0) shield.isActive = true;
      }
    }
  }
}
